// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__24Aas","vLegacy":"SelectSecondary_vLegacy__3qyVM","error":"SelectSecondary_error__RHyPT","disabled":"SelectSecondary_disabled__24x1T"};